export class ReorderSectionOptionsParams {
  recalculateDueDate: boolean;
  recalculateLastDate: boolean;
  constructor(duedate = false, lastDate = false) {
    this.recalculateDueDate = duedate;
    this.recalculateLastDate = lastDate;
  }
}